import React from "react";

const NavBar: React.FC = () => {
  return (
    <div className="text-center md:text-right">
      <a
        href="/edge-upi-rupay-credit-card"
        target="_blank"
        className={
          window.location.pathname === "/edge-upi-rupay-credit-card" ||
          window.location.pathname === "/"
            ? "pointer-events-none"
            : "cursor-pointer"
        }
      >
        <button
          className={`mt-1 mb-2 md:my-4 text-white p-2 text-xs md:text-sm rounded font-semibold mr-4
                        ${
                          window.location.pathname ===
                            "/edge-upi-rupay-credit-card" ||
                          window.location.pathname === "/"
                            ? "bg-sf60 pointer-events-none"
                            : "bg-gt5 border border-sf60 cursor-pointer text-sf60 hover:bg-sf60 hover:text-white"
                        }`}
        >
          Edge CSB Bank RuPay Credit Card
        </button>
      </a>
      <a
        href="/edge-visa-credit-card"
        target="_blank"
        className={
          window.location.pathname === "/edge-visa-credit-card"
            ? "mr-4 pointer-events-none"
            : "mr-4 cursor-pointer"
        }
      >
        <button
          className={`mt-2 mb-1 md:my-4 text-white p-2 text-xs md:text-sm rounded font-semibold
                        ${
                          window.location.pathname === "/edge-visa-credit-card"
                            ? "bg-sf60 pointer-events-none"
                            : "bg-gt5 border border-sf60 cursor-pointer text-sf60 hover:bg-sf60 hover:text-white"
                        }`}
        >
          Edge Federal Bank Visa Credit Card
        </button>
      </a>
    </div>
  );
};
export default NavBar;
